module.exports = __webpack_public_path__ + "static/img/b4.f8006c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b4.png
// module id = glN7
// module chunks = 1